module.exports = __webpack_public_path__ + "5fa5e3b3b18812639b8ece5436f7a280.m4a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/copied.m4a
// module id = IfCC
// module chunks = 1